import React, {Component} from 'react'
import PropTypes from 'prop-types'


class SearchByLocationType extends Component {
    _handleChangeLocationType = async e => {
        const {value} = e.target

        await this.props.onChange('location_type', value)
        this.props.onSubmit()
    }


    render() {
        const {filter} = this.props
        const {location_type} = filter


        return (
            <div className="SearchByLocationType mr-3 mb-2">
                <label htmlFor="" className='mb-0 font-weight-bold'>Location type</label>
                <select name="location_type" value={location_type} onChange={this._handleChangeLocationType}
                        className="form-control" style={{minWidth: 140}}>
                    <option value="all">All</option>
                    <option value="us">Thường (US)</option>
                    <option value="international">Quốc tế</option>
                </select>
            </div>
        )
    }
}

SearchByLocationType.propTypes = {
    filter: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
}

export default SearchByLocationType
